export const POPUPS_IDS = {
  LOGIN: 1,
  CONFIRMATION: 2,
};
